import { useState, useEffect } from 'react';


const s = {
  page: { minHeight: '100vh', backgroundColor: '#f5f5f3', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  topNav: { backgroundColor: '#fff', borderBottom: '0.5px solid #e8e8e8', padding: '0 32px', height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  navBrand: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.3px', display: 'flex', alignItems: 'center', gap: '8px' },
  adminBadge: { fontSize: '10px', backgroundColor: '#1a1a1a', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontWeight: '500', letterSpacing: '0.5px' },
  navRight: { display: 'flex', alignItems: 'center', gap: '16px' },
  navEmail: { fontSize: '12px', color: '#aaa' },
  navBtn: { fontSize: '13px', color: '#666', background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  content: { maxWidth: '1100px', margin: '0 auto', padding: '32px 24px' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: '6px', marginBottom: '20px', fontSize: '13px' },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '24px' },
  metricCard: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '20px', textAlign: 'center', cursor: 'pointer', transition: 'border-color 0.1s' },
  metricCardActive: { borderColor: '#1a1a1a', borderWidth: '1.5px' },
  metricNum: { fontSize: '32px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-1px', marginBottom: '4px' },
  metricLabel: { fontSize: '11px', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.8px' },
  card: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '24px' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '16px' },
  cardTitle: { fontSize: '15px', fontWeight: '600', color: '#1a1a1a', flexShrink: 0 },
  searchInput: { padding: '8px 12px', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', outline: 'none', color: '#1a1a1a', width: '280px' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '0.5px solid #e8e8e8' },
  td: { padding: '14px 12px', color: '#1a1a1a', borderBottom: '0.5px solid #f0f0f0', verticalAlign: 'middle' },
  tdActions: { padding: '14px 12px', borderBottom: '0.5px solid #f0f0f0', display: 'flex', gap: '6px', alignItems: 'center' },
  restaurantName: { fontWeight: '500', color: '#1a1a1a', marginBottom: '2px' },
  restaurantSlug: { fontSize: '11px', color: '#bbb' },
  statusCell: { display: 'flex', flexDirection: 'column', gap: '4px' },
  badgeActive: { fontSize: '11px', backgroundColor: '#f0faf4', color: '#2e7d32', padding: '3px 10px', borderRadius: '20px', fontWeight: '500', border: '0.5px solid #c8e6c9', display: 'inline-block' },
  badgeInactive: { fontSize: '11px', backgroundColor: '#fdecea', color: '#c0392b', padding: '3px 10px', borderRadius: '20px', fontWeight: '500', border: '0.5px solid #f5c6c6', display: 'inline-block' },
  badgeUnverified: { fontSize: '11px', backgroundColor: '#fff8e1', color: '#f57f17', padding: '3px 10px', borderRadius: '20px', fontWeight: '500', border: '0.5px solid #ffe082', display: 'inline-block' },
  actionBtn: { padding: '5px 12px', backgroundColor: '#fff', color: '#444', border: '0.5px solid #e0e0e0', borderRadius: '5px', fontSize: '12px', cursor: 'pointer', textDecoration: 'none' },
  actionBtnDanger: { padding: '5px 12px', backgroundColor: '#fff', color: '#c0392b', border: '0.5px solid #f5c6c6', borderRadius: '5px', fontSize: '12px', cursor: 'pointer' },
  actionBtnSuccess: { padding: '5px 12px', backgroundColor: '#f0faf4', color: '#2e7d32', border: '0.5px solid #c8e6c9', borderRadius: '5px', fontSize: '12px', cursor: 'pointer' },
  muted: { fontSize: '13px', color: '#aaa' },
};

function AdminDashboard() {
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');
  const token = localStorage.getItem('admin_token');
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [actionLoading, setActionLoading] = useState(null);

  useEffect(() => {
    if (!token) { window.location.href = '/admin'; return; }
    fetchRestaurants();
  }, [token]);

  const fetchRestaurants = async () => {
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/admin/restaurants', {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (res.status === 401) { window.location.href = '/admin'; return; }
      const data = await res.json();
      setRestaurants(data);
    } catch {
      setError('Failed to load restaurants');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (restaurant) => {
    const action = restaurant.is_active ? 'deactivate' : 'activate';
    const confirm = window.confirm(
      (restaurant.is_active ? 'Deactivate' : 'Activate') + ' ' + restaurant.name + '?'
    );
    if (!confirm) return;
    setActionLoading(restaurant.id);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/admin/restaurants/' + restaurant.id + '/' + action, {
        method: 'PATCH',
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Action failed'); return; }
      setRestaurants(restaurants.map(r => r.id === restaurant.id ? { ...r, is_active: data.is_active } : r));
    } catch {
      setError('Action failed');
    } finally {
      setActionLoading(null);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin');
    window.location.href = '/admin';
  };

  const filtered = restaurants.filter(r => {
    const matchesSearch = search === '' ||
      r.name.toLowerCase().includes(search.toLowerCase()) ||
      r.email.toLowerCase().includes(search.toLowerCase());
    const matchesFilter = filter === 'all' ||
      (filter === 'active' && r.is_active) ||
      (filter === 'inactive' && !r.is_active) ||
      (filter === 'unverified' && !r.email_verified);
    return matchesSearch && matchesFilter;
  });

  const counts = {
    all: restaurants.length,
    active: restaurants.filter(r => r.is_active).length,
    inactive: restaurants.filter(r => !r.is_active).length,
    unverified: restaurants.filter(r => !r.email_verified).length,
  };

  return (
    <div style={s.page}>
      <div style={s.topNav}>
        <span style={s.navBrand}>Menu Board <span style={s.adminBadge}>Admin</span></span>
        <div style={s.navRight}>
          <span style={s.navEmail}>{admin.email}</span>
          <button style={s.navBtn} onClick={handleLogout}>Sign out</button>
        </div>
      </div>

      <div style={s.content}>
        {error && <p style={s.error}>{error}</p>}

        <div style={s.metrics}>
          {['all', 'active', 'inactive', 'unverified'].map(key => (
            <button
              key={key}
              style={{ ...s.metricCard, ...(filter === key ? s.metricCardActive : {}) }}
              onClick={() => setFilter(key)}
            >
              <p style={s.metricNum}>{counts[key]}</p>
              <p style={s.metricLabel}>{key.charAt(0).toUpperCase() + key.slice(1)}</p>
            </button>
          ))}
        </div>

        <div style={s.card}>
          <div style={s.cardHeader}>
            <h2 style={s.cardTitle}>Restaurants</h2>
            <input
              style={s.searchInput}
              type="text"
              placeholder="Search by name or email..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {loading ? (
            <p style={s.muted}>Loading...</p>
          ) : filtered.length === 0 ? (
            <p style={s.muted}>No restaurants found.</p>
          ) : (
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Restaurant</th>
                  <th style={s.th}>Email</th>
                  <th style={s.th}>Menus</th>
                  <th style={s.th}>Staff</th>
                  <th style={s.th}>Status</th>
                  <th style={s.th}>Joined</th>
                  <th style={s.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r, i) => (
                  <tr key={r.id} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={s.td}>
                      <div style={s.restaurantName}>{r.name}</div>
                      <div style={s.restaurantSlug}>/{r.slug}</div>
                    </td>
                    <td style={s.td}>{r.email}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{r.menu_count}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{r.staff_count}</td>
                    <td style={s.td}>
                      <div style={s.statusCell}>
                        <span style={r.is_active ? s.badgeActive : s.badgeInactive}>
                          {r.is_active ? 'Active' : 'Inactive'}
                        </span>
                        {!r.email_verified && (
                          <span style={s.badgeUnverified}>Unverified</span>
                        )}
                      </div>
                    </td>
                    <td style={s.td}>
                      {new Date(r.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </td>
                    <td style={s.tdActions}>
                      <a href={'/menu/' + r.slug} target="_blank" rel="noreferrer" style={s.actionBtn}>
                        View menu
                      </a>
                      {r.is_active ? (
                        <button
                          style={s.actionBtnDanger}
                          onClick={() => handleToggle(r)}
                          disabled={actionLoading === r.id}
                        >
                          {actionLoading === r.id ? '...' : 'Deactivate'}
                        </button>
                      ) : (
                        <button
                          style={s.actionBtnSuccess}
                          onClick={() => handleToggle(r)}
                          disabled={actionLoading === r.id}
                        >
                          {actionLoading === r.id ? '...' : 'Activate'}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}


export default AdminDashboard;
